import { now } from '../utils/functions';
const MAX_ENTRIES = 500;
const entries = [];
const listeners = new Set();
let snapshot = entries.slice();
function publish() {
    snapshot = entries.slice();
    for (const listener of listeners) {
        listener();
    }
}
export function subscribeLogs(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
export function getLogs() {
    return snapshot;
}
const LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error'];
function permits(threshold, level) {
    return LOG_LEVELS.indexOf(threshold) <= LOG_LEVELS.indexOf(level);
}
function describe(value) {
    if (value instanceof Error)
        return JSON.stringify(value, Object.getOwnPropertyNames(value));
    if (typeof value === 'object' && value !== null)
        return JSON.stringify(value);
    return String(value);
}
function createLogger(consoleLevel, documentLevel) {
    const original = { ...console };
    function write(level, args) {
        if (permits(consoleLevel, level)) {
            const method = level === 'info' ? 'log' : level;
            original[method](...args);
        }
        if (permits(documentLevel, level)) {
            if (entries.length >= MAX_ENTRIES)
                entries.shift();
            entries.push({ timestamp: now(), level, content: args.map(describe).join(' ') });
            publish();
        }
    }
    return {
        trace: (...args) => write('trace', args),
        debug: (...args) => write('debug', args),
        log: (...args) => write('info', args),
        warn: (...args) => write('warn', args),
        error: (...args) => write('error', args),
    };
}
const logger = createLogger(process.env.EPHEMON_CONSOLE_LOG_LEVEL || 'info', process.env.EPHEMON_DOCUMENT_LOG_LEVEL || 'info');
console.log = logger.log;
console.error = logger.error;
console.warn = logger.warn;
console.debug = logger.debug;
console.trace = logger.trace;
export function getLogger() {
    return logger;
}
